import { Button, Grid2, IconButton, Typography } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { useMutation, useQuery } from "@tanstack/react-query";
import { ConfirmDeleteModal, GKClientDataGrid, StatusField } from "components";
import { DeleteIcon, Edit1Icon } from "components/Icons";
import DashboardLayout from "layouts/DashboardLayout";
import { useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import axiosInstance from "utils/axiosInstance";
import { extraColumnsField } from "utils/helpers";
import { QueryKeys } from "utils/queryKey";
import CreateBrokerModal from "./CreateBrokerModal";

const BrokerMaster = () => {
  const navigate = useNavigate();

  const [openBrokerModal, setOpenBrokerModal] = useState(false);
  const [brokerData, setBrokerData] = useState({});
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [brokerMasterId, setBrokerMasterId] = useState<any>(0);

  const { data, isLoading, refetch } = useQuery({
    queryKey: [QueryKeys.BROKER_MASTER_LIST],
    queryFn: () => axiosInstance.get("/broker/"),
    onError: (error: any) => {
      toast.error(error?.response?.data?.message || "Something went wrong");
    },
  });

  const { mutate: handleDeleteBroker } = useMutation({
    mutationKey: ["DELETE_BROKEN"],
    mutationFn: () => axiosInstance.delete(`/broker/${brokerMasterId}/delete/`),
    onSuccess: (response) => {
      refetch();
      toast.success(response?.data?.message || "Delete Broker Successfully");
    },
    onError: (error: any) => {
      toast.error(error?.response?.data?.message || "Something went wrong");
    },
  });

  const brokerColumns: GridColDef[] = [
    {
      ...extraColumnsField("Name", "name", 150, 1),
    },
    {
      ...extraColumnsField("Status", "status", 150, 1),
      renderCell: (params) => (
        <StatusField
          statusString={params?.row?.status ? "Active" : "Inactive"}
        />
      ),
    },
    {
      ...extraColumnsField("Integration Status", "integrationStatus", 150, 1),
      renderCell: (params) => (
        <StatusField
          statusString={params?.row?.integrationStatus ? "Active" : "Inactive"}
        />
      ),
    },
    {
      ...extraColumnsField("Meta", "meta", 150, 1),
      renderCell: (params) => (
        <Typography>
          {JSON.parse(params?.row?.meta.replace(/'/g, '"')).join(", ")}
        </Typography>
      ),
    },
    {
      ...extraColumnsField("Actions", "action", 80, 1),
      headerAlign: "right",
      align: "right",
      type: "action",
      renderCell: (item) => (
        <Grid2 container justifyContent={"flex-end"}>
          <IconButton
            color="primary"
            onClick={(event) => {
              event.stopPropagation();
              navigate(`/app/broker-master/${item.id}`);
            }}
          >
            <Edit1Icon width={20} height={20} />
          </IconButton>
          <IconButton
            color="error"
            onClick={(event) => {
              event.stopPropagation();
              setBrokerMasterId(item?.id);
              setConfirmationModal(true);
            }}
          >
            <DeleteIcon width={20} height={20} />
          </IconButton>
        </Grid2>
      ),
    },
  ];

  return (
    <DashboardLayout title="Broker Master">
      <Grid2 container spacing={2}>
        <Grid2 size={12}>
          <GKClientDataGrid
            headerComponent={
              <Grid2 size={12} display={"flex"} justifyContent={"flex-end"}>
                <Button
                  variant="contained"
                  size="medium"
                  onClick={() => {
                    setBrokerData({});
                    setOpenBrokerModal(true);
                  }}
                >
                  Create Broker Master
                </Button>
              </Grid2>
            }
            showFiltersButton={false}
            loading={isLoading}
            columns={brokerColumns}
            rows={data?.data?.data || []}
            onRowClick={(row) => {
              setBrokerData(row?.row);
              setOpenBrokerModal(true);
            }}
          />
        </Grid2>
      </Grid2>

      {openBrokerModal && (
        <CreateBrokerModal
          isModalOpen={openBrokerModal}
          setIsModalOpen={setOpenBrokerModal}
          refetch={refetch}
          brokerData={brokerData}
        />
      )}

      {confirmationModal && (
        <ConfirmDeleteModal
          open={confirmationModal}
          setOpen={setConfirmationModal}
          onDelete={() => handleDeleteBroker()}
          title={"Broker Master"}
          isDelete
        />
      )}
    </DashboardLayout>
  );
};

export default BrokerMaster;
